import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const processGroupSchema: CollectionCreateSchema = {
  name: CollectionName.ProcessGroup,
  enable_nested_fields: true,
  fields: [
    {
      name: "id",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "group_name",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "group_type",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "override_un_code",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "override_characteristic",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "active",
      type: "bool",
      sort: true,
    },
    {
      name: "updated_at",
      type: "int64",
      sort: true,
      infix: true,
    },
    {
      name: "updated_by",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
  ],
  visibility: CollectionVisibility.Public,
}
